export const locale = {
    lang: 'es',
    data: {
        EMPLEADOS: {
            LIST: {
                TITLE: 'EMPLEADOS'
            }
        }
    }
};
